var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12Z",
    stroke: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 11.4714L10.97 8.47141C11.26 8.18141 11.74 8.18141 12.03 8.47141C12.32 8.76141 12.32 9.24141 12.03 9.53141L10.31 11.2514H15.5C15.91 11.2514 16.25 11.5914 16.25 12.0014C16.25 12.4114 15.91 12.7514 15.5 12.7514H10.31L12.03 14.4714C12.32 14.7614 12.32 15.2414 12.03 15.5314C11.88 15.6814 11.69 15.7514 11.5 15.7514C11.31 15.7514 11.12 15.6814 10.97 15.5314L7.97 12.5314C7.68 12.2414 7.68 11.7614 7.97 11.4714Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2a951327657537d337e6f8494d2ace14.svg";
export { ForwardRef as ReactComponent };